import { ILoyaltyDataProvider, LoyaltyData, GettingStartedItem } from './types';
import { LoyaltyService } from './loyalty.service';
import { useSelector } from 'react-redux';

export abstract class BaseLoyaltyDataProvider implements ILoyaltyDataProvider {
  protected loyaltyService: LoyaltyService;

  constructor() {
    this.loyaltyService = new LoyaltyService();
  }

  abstract getLoyaltyData(): Promise<LoyaltyData>;
}

function generateGettingStartedItems(steps: any): GettingStartedItem[] {
  const data =
    typeof steps === "string"
      ? JSON.parse(steps)
      : steps || {};

  return [
    {
      id: 'complete-profile',
      title: 'ENTER_YOUR_BANK_DETAILS',
      completed: data?.EnterBankDetails ?? false,
      description: 'Add your business information and verify your details',
    },
    {
      id: 'send-first-invoice',
      title: 'INVITE_A_NEW_USER',
      completed: data?.InviteFreelancer ?? false,
      description: 'Create and send your first invoice to earn loyalty points',
    },
    {
      id: 'connect-bank-account',
      title: 'LEAVE_A_REVIEW_ABOUT_INVOZIO',
      completed: data?.LeaveReview ?? false,
      description: 'Link your bank account to receive payments automatically',
    },
  ];
}


// Update the providers to use the shared function
export class MockLoyaltyDataProvider extends BaseLoyaltyDataProvider {
  private mockData: LoyaltyData;

  constructor() {
    super();
    const { userOnboardingData } = useSelector((state: any) => state.auth);
    const steps = userOnboardingData?.onBoardingSteps || {};
    const gettingStartedItems = generateGettingStartedItems(steps);
    const completedCount = gettingStartedItems.filter(item => item.completed).length;
    const progress = this.loyaltyService.calculateGettingStartedProgress(completedCount, gettingStartedItems.length);

    this.mockData = {
      stats: this.loyaltyService.calculateLoyaltyStats(75),
      gettingStarted: {
        title: 'Getting Started with Invozio 🎉',
        subtitle: 'Your first step toward Economic Freedom',
        progress,
        items: gettingStartedItems,
      },
    };
  }

  async getLoyaltyData(): Promise<LoyaltyData> {
    await new Promise(resolve => setTimeout(resolve, 500));
    return this.mockData;
  }
}


export function createMockLoyaltyProvider(): ILoyaltyDataProvider {
  return new MockLoyaltyDataProvider();
}